// eslint-disable-next-line @nx/enforce-module-boundaries
import { v4 as uuidv4, validate as validateUUID } from 'uuid';

export const genUUIDV4 = uuidv4;
export const validateUUIDV4 = validateUUID;
